<mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
            This padding value depends on the mat-icon-button width. -->
  <mat-nested-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <div
      *ngIf="node.requiredRoles | hasRoles | async"
      style="padding-left: 40px"
    >
      <a
        mat-button
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
        [routerLink]="node.link"
      >
        {{ node.name }}
      </a>
    </div>
  </mat-nested-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="node" *ngIf="node.requiredRoles | hasRoles | async">
      <button
        #toggleButton
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <span
        *ngIf="!node.link"
        (click)="toggleButton._elementRef.nativeElement.click()"
        style="cursor: pointer"
      >
        <button mat-button>
          {{ node.name }}
        </button>
      </span>
      <a
        style="margin-left: -8px"
        (click)="toggleButton._elementRef.nativeElement.click()"
        *ngIf="node.link"
        mat-button
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="node.link"
      >
        {{ node.name }}
      </a>
    </div>

    <div
      *ngIf="node.requiredRoles | hasRoles | async"
      style="padding-left: 15px"
      [class.tree-invisible]="!tree.isExpanded(node)"
      role="group"
    >
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
